import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getUser, updateUser, deleteUser } from '@/api/users';
import type { UpdateUserRequest } from '@/types/user';

/**
 * Hook to fetch the current user's profile.
 */
export function useUser() {
  return useQuery({
    queryKey: ['user'],
    queryFn: getUser,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

/**
 * Hook to update the current user's profile.
 */
export function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateUserRequest) => updateUser(data),
    onSuccess: (updatedUser) => {
      queryClient.setQueryData(['user'], updatedUser);
    },
  });
}

/**
 * Hook to delete the current user's account.
 */
export function useDeleteUser() {
  return useMutation({
    mutationFn: deleteUser,
  });
}
